export default {
  GAME_TITLE: 'Ludum Dare 41!',
  STORY: 'Theme: Combine 2 Incompatible Genres',
  START: 'Press ENTER to Play!',
  INSTRUCTIONS: 'Press Shift + left/right arrow to move the blocks\nand shift + up arrow to rotate them\n\nPress the arrow keys without shift to move the blob\n\nClimb the blocks to reach the door',
  RESTART: 'Press enter to try again!',
  GAMEOVER: 'GAME OVER'
};



/** WEBPACK FOOTER **
 ** ./scripts/Enums/index.js
 **/